"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickupPointCards = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../../../contexts");
var _pickupPointsContext = require("../../../../contexts/pickupPointsContext");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _Loading = require("../../../Loading");
var _PickupPointCard = require("../PickupPointCard");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PickupPointCards = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    selectedDelivery
  } = (0, _contexts.useMap)();
  const {
    isLoading,
    isValidating,
    error,
    pickupPoints,
    hasMore,
    loadMore
  } = (0, _pickupPointsContext.usePickupPoints)();

  // Scrolls to the selected pickup point when selectedPickupPointId changes
  const rootRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const root = rootRef.current;
    const element = root?.querySelector(`[data-id="${selectedDelivery}"]`);
    if (!root || !element) {
      return;
    }
    root.scrollTo({
      top: element.getBoundingClientRect().top + root.scrollTop - root.getBoundingClientRect().top,
      behavior: 'smooth'
    });
  }, [selectedDelivery, rootRef]);
  const loadMoreRef = (0, _react.useRef)(null);

  // TODO: Extract to a reusable hook
  // Observer for infinite scroll
  (0, _react.useEffect)(() => {
    if (!loadMoreRef.current || !rootRef.current) {
      return () => {};
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          void loadMore();
        }
      });
    }, {
      rootMargin: '100px',
      root: rootRef.current
    });
    observer.observe(loadMoreRef.current);
    return () => observer.disconnect();
  }, [loadMore]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    ref: rootRef,
    "data-testid": getTestId(_models.TestId.PickupPointCards),
    children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointCard.PickupPointCardSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointCard.PickupPointCardSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointCard.PickupPointCardSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointCard.PickupPointCardSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointCard.PickupPointCardSkeleton, {})]
    }) : pickupPoints.length === 0 && !isValidating ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Alert, {
      severity: "warning",
      children: formatMessage('noPickupPointsFound')
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [pickupPoints.map(pickupPoint => /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointCard.PickupPointCard, {
        ...pickupPoint
      }, pickupPoint.deliveryChannelId)), !!hasMore && (error && !isValidating ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Alert, {
        severity: "error",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          onClick: loadMore,
          children: "Retry"
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LoadingWrapper, {
        ref: loadMoreRef,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {})
      }))]
    })
  });
};
exports.PickupPointCards = PickupPointCards;